"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Builder;
Object.defineProperty(exports, "Form", {
  enumerable: true,
  get: function get() {
    return _materialUi.default;
  }
});

var _react = _interopRequireDefault(require("react"));

var _materialUi = _interopRequireDefault(require("@rjsf/material-ui"));

var _Builder = _interopRequireDefault(require("./Components/Builder"));

var _schemaStore = _interopRequireDefault(require("./state/schema-store"));

var _uiSchemaStore = _interopRequireDefault(require("./state/ui-schema-store"));

var _languageStore = _interopRequireDefault(require("./state/language-store"));

var _styles = require("@material-ui/core/styles");

// Components
// Stores
// Material UI
var theme = (0, _styles.createMuiTheme)({
  overrides: {
    MuiSpeedDialAction: {
      staticTooltipLabel: {
        width: "max-content"
      }
    }
  }
});
theme = (0, _styles.responsiveFontSizes)(theme);

function Builder(_ref) {
  var languageOptions = _ref.languageOptions,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement(_languageStore.default, {
    languageOptions: languageOptions
  }, /*#__PURE__*/_react.default.createElement(_schemaStore.default, {
    schema: schema
  }, /*#__PURE__*/_react.default.createElement(_uiSchemaStore.default, {
    uiSchema: uiSchema
  }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_Builder.default, {
    onChange: onChange
  })))));
}